import TemplateView from "../../../../TemplateView"
import {connect} from "../../../../redux/utils"
import ClassicBridge from '../../../../next/ClassicBridge'
import {isAccountSettingsTabVisible, isPTOTabVisible, isSDBTabVisible} from '../../common/selectors'
import {UserInfoRepository} from './util/UserInfoRepository'

class ExportUsersDropdown extends TemplateView{
    constructor() {
        super(null)

        this.state = {
            filter: {},
            tokens: [],
            userListOrder: {},
            userCount: 0,
            balanceHoursPerDay: 0,
            isAccountSettingsVisible: false,
            isPtoVisible: false,
            isSickDaysVisible: false,
            isDisabled: false,
        }

        this.userInfoRepository = new UserInfoRepository()

        this.onStatePropertyChanged('filter', filter => {
            this.userInfoRepository.updateFilter(filter)
        })

        this.onStatePropertyChanged('tokens', tokens => {
            this.userInfoRepository.updateTokens(tokens)
        })

        this.onStatePropertyChanged('userListOrder', userListOrder => {
            this.userInfoRepository.updateUserListOrder((userListOrder))
        })

        this.onStatePropertyChanged('userCount', userCount => {
            this.userInfoRepository.updateUserCount((userCount))
        })

        this.onStatePropertyChanged('balanceHoursPerDay', balanceHoursPerDay => {
            this.userInfoRepository.updateBalanceHoursPerDay((balanceHoursPerDay))
        })

        this.onStatePropertyChanged('isAccountSettingsVisible', isAccountSettingsVisible => {
            this.exportCPDropdown.setProps(({ isAccountSettingsVisible }))
        })

        this.onStatePropertyChanged('isSickDaysVisible', isSickDaysVisible => {
            this.exportCPDropdown.setProps(({ isSickDaysVisible }))
        })

        this.onStatePropertyChanged('isPtoVisible', isPtoVisible => {
            this.exportCPDropdown.setProps(({ isPtoVisible }))
        })

        this.onStatePropertyChanged('isDisabled', isDisabled => {
            this.exportCPDropdown.setProps(({ isDisabled }))
        })
    }

    templateHtml(){
        return "<div class='atNextMount exportUsersMount'></div>";
    }

    afterRender()
    {
        this.exportCPDropdown = ClassicBridge.integrateExportUsersDropdown(this.$el[0], {
            classicUserInfosRepository: this.userInfoRepository
        })
    }
}

export default connect(
    (state) => ({
        isAccountSettingsVisible: isAccountSettingsTabVisible(state),
        isPtoVisible: isPTOTabVisible(state),
        isSickDaysVisible: isSDBTabVisible(state),
    })
)(ExportUsersDropdown)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/managementButtons/ExportUsersDropdown.js